// Libraries
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { MapContainer, ImageOverlay, CircleMarker } from 'react-leaflet';
import { CRS } from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';

// Enums
import { ImageQuestionDataType } from 'engagementReport/enums/propTypes';

// Hooks
import useImageMapData from 'engagementReport/hooks/useImageMapData';

const ImageMap = ({ data, imageUrl }) => {
  const imageMapData = useImageMapData(imageUrl);

  if (!imageMapData) {
    return null;
  }

  const { center, bounds, maxBounds } = imageMapData;
  const whenCreated = (map) => {
    map.fitBounds(imageMapData.bounds, { animate: false });
    map.setMinZoom(map.getZoom());
  };

  return (
    <MapContainer
      className="image-report-map"
      center={center}
      maxBounds={maxBounds}
      zoom={0}
      minZoom={-2}
      maxZoom={2}
      crs={CRS.Simple}
      scrollWheelZoom={false}
      zoomSnap={0}
      zoomDelta={0.5}
      whenCreated={whenCreated}
    >
      <ImageOverlay url={imageUrl} bounds={bounds} />
      <MarkerClusterGroup>
        {data.map(({ id, x, y }) => (
          <CircleMarker
            key={id}
            center={[y, x]}
            radius={5}
            color="#000000"
            weight={1}
            fill
            fillColor="#de685d"
            fillOpacity={1}
          />
        ))}
      </MarkerClusterGroup>
    </MapContainer>
  );
};

ImageMap.propTypes = {
  data: ImageQuestionDataType.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default memo(ImageMap);
